import { Directive, ElementRef, forwardRef, HostListener, inject } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { formatSSN, normalizeSSN } from './ssn-format.utils';

@Directive({
  selector: '[appSsnFormatter]',
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SsnFormatterDirective),
      multi: true,
    },
  ],
})
export class SsnFormatterDirective implements ControlValueAccessor {
  private el = inject(ElementRef);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private onChange = (value: string) => {
    // no-op
  };
  private onTouched = () => {
    // no-op
  };

  writeValue(value: string): void {
    this.inputElement.value = value ? formatSSN(value) : '';
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.inputElement.disabled = isDisabled;
  }

  private get inputElement(): HTMLInputElement {
    return this.el.nativeElement as HTMLInputElement;
  }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const value = normalizeSSN(input.value);
    input.value = formatSSN(value);
    this.onChange(value); // send digits only to form control
    this.onTouched(); // mark as touched on input for immediate validation display
  }

  @HostListener('blur')
  onBlur() {
    this.onTouched();
  }
}
